/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MoarBase, MoarBaseInterface } from "../MoarBase";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurnningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum MoarBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MoarBaseConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MoarBaseConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MoarBase__factory extends ContractFactory {
  constructor(...args: MoarBaseConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "MoarBase";
  }

  deploy(
    admin: string,
    royaltyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MoarBase> {
    return super.deploy(
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<MoarBase>;
  }
  getDeployTransaction(
    admin: string,
    royaltyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(admin, royaltyAddress, overrides || {});
  }
  attach(address: string): MoarBase {
    return super.attach(address) as MoarBase;
  }
  connect(signer: Signer): MoarBase__factory {
    return super.connect(signer) as MoarBase__factory;
  }
  static readonly contractName: "MoarBase";
  public readonly contractName: "MoarBase";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoarBaseInterface {
    return new utils.Interface(_abi) as MoarBaseInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MoarBase {
    return new Contract(address, _abi, signerOrProvider) as MoarBase;
  }
}
